import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30b05fb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = { class: "footer-company-other-text" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"20px"} }, "copyright©️2023 北京虎贲文化发展有限公司 版权所有. All rights reserved.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {"margin-left":"20px","text-decoration":"none","color":"#999"},
  href: "https://beian.miit.gov.cn/"
}, "京ICP备11027947号-6", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"20px"} }, "copyright©️2024 北京盈海智胜科技有限公司 版权所有. All rights reserved.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {"margin-left":"20px","text-decoration":"none","color":"#999"},
  href: "https://beian.miit.gov.cn/"
}, "京ICP备2024077832号-1", -1))

import {computed} from "vue";


const __default__ = {
  name: "Footer"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

var company = computed(() => {
  if (location.hostname.endsWith("skyelearning.cn")) {
    return 'hf';
  }
  return null;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(company) === 'hf')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _hoisted_4
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_5,
            _hoisted_6
          ], 64))
    ])
  ]))
}
}

})